import SendReActivationEmail from './SendReActivationEmail'

export default SendReActivationEmail;
